export const save = (theme) => {
    // localStorage.setItem("app-theme", JSON.stringify(vars));
    window.sessionStorage.setItem("app-theme", JSON.stringify(theme));
};

export const get = () => {
    // localStorage.getItem("app-theme")
    return window.sessionStorage.getItem("app-theme");
};
